const TARGET_CONTENT_TYPE_STORY = 'story';
const TARGET_CONTENT_TYPE_VIDEO = 'video';

export default class VideoUploaderUtil {
  constructor(extension) {
    this.extension = extension;
  }

  getTargetContentType() {
    return this.extension.parameters.instance.target_content_type;
  }

  isTargetedForStory() {
    return this.getTargetContentType() === TARGET_CONTENT_TYPE_STORY;
  }

  isTargetedForVideo() {
    return this.getTargetContentType() === TARGET_CONTENT_TYPE_VIDEO;
  }

  setTitleOfVideoEntryIfEmpty(title) {
    const titleField = this.extension.entry.fields.title;
    if (!titleField.getValue()) {
      this.extension.entry.fields.title.setValue(title).then((result) => {
        console.log('Successfully set title: ', result);
      }).catch((error) => {
        console.error('Error during setting a title', error);
      });
    }
  }
}
